export { default as AdRingier } from '@widgets/AdRingier'
export { default as AdTeads } from '@widgets/AdTeads'
export { default as ArticleLeadContent } from '@widgets/ArticleLeadContent'
export { default as ArticleMainContent } from '@widgets/ArticleMainContent'
export { default as ArticleSidebarContent } from '@widgets/ArticleSidebarContent'
export { default as ArticleSummary } from '@widgets/ArticleSummary'
export { default as ArticleTextbox } from '@widgets/ArticleTextbox'
export { default as ArticleQuestion } from '@widgets/ArticleQuestion'
export { default as Author } from '@widgets/Author'
export { default as AuthorHeadline } from '@widgets/AuthorHeadline'
export { default as BlickBites } from '@widgets/Video/BlickBites'
export { default as BlueSky } from '@widgets/SocialEmbed/BlueSky'
export { default as Body } from '@widgets/Body'
export { default as BrandStudio } from '@widgets/BrandStudio'
export { default as Breadcrumb } from '@widgets/Breadcrumb'
export { default as Bulletpoints } from '@widgets/Bulletpoints'
export { default as Calendar } from '@widgets/Calendar'
export { default as Carousel } from '@widgets/Carousel'
export { default as Chunk } from '@widgets/Chunk'
export { default as ColumnList } from '@widgets/ColumnList'
export { default as Commenting } from '@widgets/Commenting'
export { default as CommentingSection } from '@widgets/CommentingSection'
export { default as ContainerPiano } from '@widgets/ContainerPiano'
export { default as CountingPixels } from '@widgets/CountingPixels'
export { default as CueLive } from '@widgets/CueLive'
export { default as DataWrapper } from '@widgets/Tool/DataWrapper'
export { default as DossierTabs } from '@widgets/DossierTabs'
export { default as EmbeddedContent } from '@widgets/EmbeddedContent'
export { default as ExpandableText } from '@widgets/ExpandableText'
export { default as Facebook } from '@widgets/SocialEmbed/Facebook'
export { default as FeaturedVideos } from '@widgets/FeaturedVideos'
export { default as FeatureFlagDashboard } from '@widgets/FeatureFlagDashboard'
export { default as FormIO } from '@widgets/Tool/FormIO'
export { default as Gallery } from '@widgets/Gallery'
export { default as Headline } from '@widgets/Headline'
export { default as HeadlineLead } from '@widgets/HeadlineLead'
export { default as Hearken } from '@widgets/Tool/Hearken'
export { default as HeimspielLineup } from '@widgets/HeimspielLineup'
export { default as HeimspielLiveCenter } from '@widgets/HeimspielLiveCenter'
export { default as HeimspielLiveticker } from '@widgets/HeimspielLiveticker'
export { default as HeimspielRanking } from '@widgets/HeimspielRanking'
export { default as HeimspielResult } from '@widgets/HeimspielResult'
export { default as HeimspielSchedule } from '@widgets/HeimspielSchedule'
export { default as HeimspielStartingLineup } from '@widgets/HeimspielStartingLineup'
export { default as HeimspielStartingList } from '@widgets/HeimspielStartingList'
export { default as HeimspielStatistics } from '@widgets/HeimspielStatistics'
export { default as HeimspielWorldCup } from '@widgets/HeimspielWorldCup'
export { default as HeroModule } from '@widgets/HeroModule'
export { default as SectionSummary } from '@widgets/SectionSummary'
export { default as Ingredients } from '@widgets/Ingredients'
export { default as Instagram } from '@widgets/SocialEmbed/Instagram'
export { default as LayoutCard } from '@widgets/LayoutCardIngredients'
export { default as LayoutCardSteps } from '@widgets/LayoutCardSteps'
export { default as LayoutTabs } from '@widgets/LayoutTabs'
export { default as LeadImage } from '@widgets/LeadImage'
export { default as Leserreporter } from '@widgets/Tool/Leserreporter'
export { default as LinkCarousel } from '@widgets/LinkCarousel'
export { default as Listicle } from '@widgets/Listicle'
export { default as Lotto } from '@widgets/Lotto'
export { default as MoreAbout } from '@widgets/MoreAbout'
export { default as OfferPageWithRecommendations } from '@widgets/OfferPageWithRecommendations'
export { default as PianoInline } from '@widgets/PianoInline'
export { default as Playlist } from '@widgets/Video/playlist'
export { default as Podigee } from '@widgets/Tool/Podigee'
export { default as Quote } from '@widgets/Quote'
export { default as Recommendations } from '@widgets/Recommendations'
export { default as RelatedItems } from '@widgets/RelatedItems'
export { default as RelatedMatches } from '@widgets/RelatedMatches'
export { default as RecentMatchOutcomes } from '@widgets/RecentMatchOutcomes'
export { default as EntityRelatedMatches } from '@widgets/EntityRelatedMatches'
export { default as Riddle } from '@widgets/Tool/Riddle'
export { default as Scoreboard } from '@widgets/Scoreboard'
export { default as Search } from '@widgets/Search'
export { default as Sectional } from '@widgets/Sectional'
export { default as SectionHeader } from '@widgets/SectionHeader'
export { default as SectionPaginatedContent } from '@widgets/SectionPaginatedContent'
export { default as SocialShare } from '@widgets/SocialShare'
export { default as Source } from '@widgets/Source'
export { default as SportTableInline } from '@widgets/SportTableInline'
export { default as StadiumInfo } from '@widgets/StadiumInfo'
export { default as StartInfo } from '@widgets/StartInfo'
export { default as Tags } from '@widgets/Tags'
export { default as TeaserBite } from '@widgets/TeaserBite'
export { default as TeaserListItem } from '@widgets/TeaserListItem'
export { default as TeaserMiddleToi } from '@widgets/TeaserMiddleToi'
export { default as TeaserStandardHorizontal } from '@widgets/TeaserStandardHorizontal'
export { default as TeaserStandardHybrid } from '@widgets/TeaserStandardHybrid'
export { default as TeaserStandardVertical } from '@widgets/TeaserStandardVertical'
export { default as TeaserStandardVerticalVideo } from '@widgets/TeaserStandardVerticalVideo'
export { default as TeaserToi } from '@widgets/TeaserToi'
export { default as TeaserToiCommercial } from '@widgets/TeaserToiCommercial'
export { default as TeaserToiVideo } from '@widgets/TeaserToiVideo'
export { default as TextBody } from '@widgets/TextBody'
export { default as TikTok } from '@widgets/SocialEmbed/TikTok'
export { default as Timestamps } from '@widgets/Timestamps'
export { default as Title } from '@widgets/Title'
export { default as Toplist } from '@widgets/Toplist'
export { default as Topthemen } from '@widgets/Topthemen'
export { default as TripletModule } from '@widgets/TripletModule'
export { default as Twitter } from '@widgets/SocialEmbed/Twitter'
export { default as UltraModule } from '@widgets/UltraModule'
export { default as Usersnap } from '@widgets/Tool/Usersnap'
export { default as VideoWidget } from '@widgets/Video/VideoWidget'
export { default as Vimeo } from '@widgets/Video/Vimeo'
export { default as VideosCarousel } from '@widgets/VideosCarousel'
export { default as Youtube } from '@widgets/Video/Youtube'
export { default as Zattoo } from '@widgets/Video/Zattoo'
export { default as TabsContainer } from '@widgets/TabsContainer'
export { default as EntityHeader } from '@widgets/EntityHeader'
export { default as SportCompetitorsList } from '@widgets/SportCompetitorsList'
